import React from "react";
import { useNavigate } from "react-router-dom";
import { Create } from "adminApi/SupplierListApi/SupplierList";
import fields from "../json/SupplierFields.json";
import { validateForm } from "utils/validation";
import { SupplierValidationRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddSupplierForm from "./Componates/AddSupplierForm";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";

const AddSupplier = () => {
  const navigate = useNavigate();
  const { formdata } = fields;

  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange, setErrors } = useFormChange(
    initialValues,
    SupplierValidationRules
  );

  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const formData = new FormData();
      Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
      return await Create({ data: formData });
    },
    (vals) => {
      const err = validateForm(vals, SupplierValidationRules);
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Supplier created successfully."
  );

  return (
    <>
      {loadingSubmit && <Spinner isSpinner />}
      <AddSupplierForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
      />
    </>
  );
};

export default AddSupplier;
